(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'SchoolDistrict'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, SchoolDistrict) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_TEACHER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.schoolDistricts = [];

        loadSchoolDistricts();

        function loadSchoolDistricts() {
            SchoolDistrict.query(function(result) {
                vm.schoolDistricts = result;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
